import React, { useState } from "react";
import Grid from "styled-components-grid";
import Input from "../UI/Form/Input";
import { Button } from "../../Theme/Hyper";
import styled from "styled-components";

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const List = styled.div`
  display: flex;
  height: 100px;
  overflow-y: auto;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  th:nth-child(1) {
    width: 30px;
  }
  th:nth-child(3) {
    width: 30px;
  }
  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: 30px;
    padding: 4px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
    > td > div {
      color: #ea1047;
    }
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;

export default function Category({ competition, updateCompetition }) {
const [newCategory, setNewCategory] = useState("");
const [update, setUpdate] = useState(false);
const addCategory = () => {
    if (newCategory.trim() !== "") {

    const title = newCategory.trim();
    const categoryset = [
        title,
        `${title} Landed`,
        `${title} Missed`,
    ];

    const currentCategories = competition.categories ? [...competition.categories] : [];
    const updatedCategories = [...currentCategories, ...categoryset];

    const newCompetition = { ...competition, categories: updatedCategories };
    updateCompetition(newCompetition);
    setNewCategory("");
    }
};

return (
    <>
    <Row>
    <Input
    title="Stats Categories"
        value={newCategory}
        onChange={(e) => setNewCategory(e.target.value)}
        onKeyPress={(e) => e.key === "Enter" && addCategory()}
    />
    {newCategory.trim() !== "" && (
        <Button style={{width: "20%",
            marginBottom: "10px",
            alignSelf: "flex-end",
        }}
         onClick={() => {
            addCategory();
            setUpdate(!update);
         }}
         >Add Category</Button>
        )}
    </Row>
    
      <List>
              <Table>
                <thead>
                  <tr>
                    <TH>#</TH>
                    <TH>Categories</TH>
                    <TH></TH>
                  </tr>
                </thead>
                <tbody>
                    {
                    competition.categories && 
                    competition.categories.reduce((acc, cat, i) => {
                        if (i % 3 === 0) acc.push([]);
                        acc[acc.length - 1].push({ cat, originalIndex: i });
                        return acc;
                    }, []).map((group, groupIndex) => (
                        <tr key={groupIndex}>
                        <td>{groupIndex + 1}</td>
                        <td>
                            <div style={{ display: 'flex', gap: '10px' }}>
                            {group.map((item, i) => (
                                <span key={i}>{item.cat}{i < group.length - 1 ? ',' : ''}</span>
                            ))}
                            </div>
                        </td>
                        <td>
                            <Button
                            onClick={() => {
                                let currentCategories = [...competition.categories];
                                const indicesToRemove = group.map(item => item.originalIndex);
                                
                                const newCategoriesList = currentCategories.filter((_, idx) => 
                                !indicesToRemove.includes(idx)
                                );

                                let newCompetition = { ...competition, categories: newCategoriesList };
                                updateCompetition(newCompetition);
                                setUpdate(!update);
                            }}
                            >
                            Delete Block
                            </Button>
                        </td>
                        </tr>
                    ))
                    }
                </tbody>
              </Table>
            </List>
     </>
 );
}